import { useNavigate } from "react-router-dom";
import { get, post } from "../_services/apiService";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { API_URL } from "../_services/apiUrl";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import Layout from "./Shared/Layout";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [passdwordUpdate, setPasswordUpdate] = useState(false);
    const [showEmailOtpInput, setShowEmailOtpInput] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [otp, setOtp] = useState('');
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        emailId: email || '',
        Password: "",
        ConfirmPassword: "",
    });

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    // Update formData on email prop change (if email can change dynamically)
    useEffect(() => {
        if (email) {
            setFormData((prevState) => ({
                ...prevState,
                emailId: email
            }));
        }
    }, [email]);

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    // Email validation function
    const validateEmail = (email) => {
        const isValid = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
        return isValid;
    };

    const onForgotPassword = async (e) => {
        e.preventDefault();
        if (!validateEmail(email)) {
            toast.error("Please enter a valid email address");
            return;
        }

        setLoading(true);

        try {
            const response = await get(API_URL?.ForgotPassword + `?pEmailId=${email}`);

            if (response.isSuccess === 200) {
                setShowOtpInput(true);
                toast.success('Sent otp to your Email Successfully');
            } else {
                setError("Please try again later.");
            }
        } catch (error) {
            setError("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const verifyOtp = async () => {
        if (!otp) {
            toast.error("Please enter the OTP");
            return;
        }

        setLoading(true);

        try {
            const response = await post(API_URL.VerifyOTP, {
                mobileNo: `${email}`,
                otp: otp,
            });

            if (response.isSuccess === 200) {
                toast.success("OTP Verified Successfully");
                setPasswordUpdate(true);
                setShowEmailOtpInput(false);
                setOtp("");
            }
        } catch (error) {
            toast.error("Failed to Verify OTP");
        } finally {
            setLoading(false);
        }
    };

    // Update Password function
    const updatePassword = async () => {
        if (formData.Password !== formData.ConfirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        setLoading(true);
        try {
            const response = await post(API_URL.UpdatePasswordByLoginDetailById, formData);

            if (response.isSuccess === 200) {
                toast.success("Password updated successfully");
                navigate('/login');
            } else {
                toast.error("Failed to update password");
            }
        } catch (error) {
            toast.error("Failed to verify OTP");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <Layout>
                <section className='userlogin layout_main'>
                    <div className='all_cente_login'>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className='col-xl-4 col-lg-5 col-md-7 col-sm-10 col-12'>
                                    <div className='userloginform'>
                                        <div className='userform-heading'>
                                            <h4>Forgot Password</h4>
                                        </div>
                                        <form>
                                            {showEmailOtpInput && (
                                                <>
                                                    <div className="form-outline mb-4">
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            id="email"
                                                            className="form-control"
                                                            required
                                                            placeholder="Enter Email Address"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                        />
                                                    </div>

                                                    {showOtpInput && (
                                                        <div className="form-outline mb-4">
                                                            <input
                                                                type="text"
                                                                name="otp"
                                                                id="otp"
                                                                placeholder="Enter OTP"
                                                                value={otp}
                                                                onChange={(e) => setOtp(e.target.value)}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    )}

                                                    <div className="user-loginbtn text-white mb-2 forgot_password">
                                                        <button
                                                            type="button"
                                                            className=""
                                                            onClick={showOtpInput ? verifyOtp : onForgotPassword}
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <ClipLoader color="#fff" size={20} />
                                                            ) : (
                                                                showOtpInput ? 'Verify OTP' : 'Send OTP'
                                                            )}
                                                        </button>
                                                    </div>
                                                </>
                                            )}

                                            {passdwordUpdate && (
                                                <>
                                                    <div className="form-outline mb-4">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            name="Password"
                                                            className="form-control"
                                                            placeholder="Password"
                                                            required
                                                            value={formData.Password}
                                                            onChange={handleChange}
                                                        />
                                                        {formData.Password !== '' ?
                                                            <span
                                                                onClick={togglePasswordVisibility}
                                                                className={`password-eye-icon ${showPassword ? 'password-eye-icon-visible' : 'password-eye-icon-hidden'}`}
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '20px',
                                                                    top: '45%',
                                                                    transform: 'translateY(-50%)',
                                                                    zIndex: '10'
                                                                }}
                                                            >
                                                                {/* {showPassword ? <FaEyeSlash /> : <FaEye />} */}
                                                            </span> : null
                                                        }
                                                    </div>
                                                    <div className="form-outline mb-4">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            name="ConfirmPassword"
                                                            className="form-control"
                                                            placeholder="Confirm Password"
                                                            required
                                                            value={formData.ConfirmPassword}
                                                            onChange={handleChange}
                                                        />
                                                        {formData.ConfirmPassword !== '' ?
                                                            <span
                                                                onClick={toggleConfirmPasswordVisibility}
                                                                className={`password-eye-icon ${showConfirmPassword ? 'password-eye-icon-visible' : 'password-eye-icon-hidden'}`}
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '20px',
                                                                    top: '45%',
                                                                    transform: 'translateY(-50%)',
                                                                    zIndex: '10'
                                                                }}
                                                            >
                                                                {/* {showConfirmPassword ? <FaEyeSlash /> : <FaEye />} */}
                                                            </span> : null
                                                        }
                                                    </div>
                                                    <div className="user-loginbtn text-white mb-2 forgot_password">
                                                        <button
                                                            type="button"
                                                            className=""
                                                            onClick={updatePassword}
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <ClipLoader color="#fff" size={20} />
                                                            ) : (
                                                                "Update Password"
                                                            )}
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    )
}

export default ForgotPassword;